
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M5.814 14.69l7.322-9.469c.398-.51.54-1.1.406-1.702-.114-.546-.45-1.066-.955-1.46l-1.229-.976c-1.07-.851-2.396-.762-3.157.215L7.38 2.364a.315.315 0 00.053.439l2.122 1.702a.875.875 0 01.274.528.787.787 0 01-.68.869.705.705 0 01-.54-.152L6.424 4.012a.26.26 0 00-.354.045L.88 10.775c-.337.421-.452.968-.337 1.496l.663 2.876c.036.152.168.26.328.26l2.918-.036a1.753 1.753 0 001.362-.681zm4.086-.896h4.758c.464 0 .842.383.842.853a.848.848 0 01-.842.853H9.9a.848.848 0 01-.842-.853c0-.47.377-.853.842-.853z"}})])
          )
        }
      }
    